module.exports = __webpack_public_path__ + "img/icon-map-implantation-05.2815e2d4.svg";